import { useTranslation } from "react-i18next";
import { GridColDef, GridColumnHeaderParams, GridRenderCellParams } from "@mui/x-data-grid-pro";

import { LoadingSkeleton } from "../../../components/LoadingSkeleton";
import { TableBillingStatusTagCell } from "../../../components/TableBillingStatusTagCell/TableBillingStatusTagCell";
import { TableCellWithRightArrow } from "../../../components/TableCellWithRightArrow";
import { TableDeleteBillingCell } from "../../../components/TableDeleteBillingCell";
import { TablePriceCell } from "../../../components/TablePriceCell";
import { BillingStatus } from "../../../types/billings";
import { IColumnValuePair } from "../../../types/table";
import { getTableColumnUtils } from "../../../utils/tables/getTableColumnUtils";
import { columnLabels, ColumnType } from "./billingsTableColumnTypes";
import { BillingsTableHeaderCell } from "./BillingsTableHeaderCell";

const columnFlexValuePairs: IColumnValuePair<ColumnType>[] = [
  {
    name: ColumnType.year,
    value: 2,
  },
  {
    name: ColumnType.status,
    value: 2,
  },
  {
    name: ColumnType.expenseSummary,
    value: 2,
  },
  {
    name: ColumnType.totalCollectedFeeSum,
    value: 2,
  },
  {
    name: ColumnType.balance,
    value: 3,
  },
];

const columnMinWidthValuePairs: IColumnValuePair<ColumnType>[] = [];

export const useGetBillingsTableColumns = () => {
  const { t } = useTranslation();
  const { getFlex, getMinWidth } = getTableColumnUtils();

  const columns: GridColDef[] = columnLabels.map((label) => {
    const columnObject: GridColDef = {
      field: label,
      headerName: t(label),
      type: "string",
      renderHeader: (params: GridColumnHeaderParams) => {
        return <BillingsTableHeaderCell params={params} />;
      },
      flex: getFlex(label, columnFlexValuePairs),
      minWidth: getMinWidth(label, columnMinWidthValuePairs),
    };

    columnObject.renderCell = (params: GridRenderCellParams) => {
      if (params.row.isMocked) {
        return <LoadingSkeleton />;
      }

      switch (label) {
        case ColumnType.year:
          return <span style={{ fontWeight: "500" }}>{params.value}</span>;
        case ColumnType.status:
          return <TableBillingStatusTagCell params={params} />;
        case ColumnType.expenseSummary:
        case ColumnType.totalCollectedFeeSum:
          return <TablePriceCell params={params} />;
        case ColumnType.balance: {
          const rightComponent = params.row.status === BillingStatus.New && (
            <TableDeleteBillingCell billingId={params.row.billingId} billingYear={params.row.year} />
          );

          return (
            <TableCellWithRightArrow
              mainComponent={<TablePriceCell params={params} />}
              rightComponent={rightComponent}
            />
          );
        }
        default:
          break;
      }
    };

    return columnObject;
  });

  return columns;
};
